import type {
  WidthConstraintResponsive,
  WidthConstraintSize,
} from './WidthConstraint';

/** Use this prop to extend components props with constrained max-width. */
export interface ConstraintsProps {
  /**
   * Set the component’s max-width to a {@link WidthConstraint}. Can be set for
   * all or for each {@link Breakpoint}.
   *
   * @example
   *
   * ```ts
   * const responsiveConstraint: WidthConstraintResponsive = {
   *   xs: 'sm', // Use small-width constraint from extra-small viewports
   *   lg: 'md', // Use medium-width constraint from large viewports
   * };
   *
   * const defaultConstraint: WidthConstraintSize = 'md'; // Use medium-width constraint for all viewports
   * ```
   */
  widthConstraint?: WidthConstraintSize | WidthConstraintResponsive;
}

export const responsiveWidthConstraint: WidthConstraintResponsive = {
  xs: 'sm',
  lg: 'md',
};

export const widthConstraint: WidthConstraintSize = 'md';
